import React from 'react';
import '../Style/EyeSenseAnimation.css';

const EyeSenseAnimation = () => {
  return (
    <div className="eyesense-anim-container">
      <div className="eyesense-anim-grid"></div>
      <div className="eyesense-anim-scanline"></div>
      
      <div className="eyesense-anim-camera">
        <div className="eyesense-anim-rec"></div>
        <span>REC CAM-04</span>
      </div>

      <div className="eyesense-anim-target-1"></div>
      <div className="eyesense-anim-threat"></div>

      <div className="eyesense-anim-overlay-stats">
        <span>SYS: ONLINE</span>
        <span>AI MODEL: ACTIVE</span>
        <span>ZONE: PERIMETER-B</span>
        <span className="alert-text">STATUS: THREAT DETECTED</span>
      </div>
    </div>
  );
};

export default EyeSenseAnimation;
